import {HierarchyNodeMetadata} from '@domain/shared'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'

import {KpisQueryKey} from '../../types'

const QueryKeyPrefix = KpisQueryKey.Hierarchy

type Options<TSelect> = Omit<
  UseQueryOptions<HierarchyNodeMetadata, AxiosError, TSelect>,
  'queryKey' | 'queryFn'
> & {
  onError?: (error: AxiosError) => void
}

export const useHierarchy = <TSelect = HierarchyNodeMetadata>(options?: Options<TSelect>) => {
  const query = useQuery<HierarchyNodeMetadata, AxiosError, TSelect>({
    queryKey: [QueryKeyPrefix],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<HierarchyNodeMetadata>(
        '/kpi/dashboard/hierarchy',
        {
          signal
        }
      )

      return response.data
    },
    refetchOnMount: false,
    staleTime: Infinity,
    ...options
  })

  const onError = options?.onError
  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return query
}